module.exports = __webpack_public_path__ + "img/Green Plastic.8e1b10e8.jpg";